import { LOAD_NETWORKUSERS } from '../../smart_contract/constants/ActionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case LOAD_NETWORKUSERS: {
      return action.payload;
    }
    default:
      return state;
  }
};
